import { RadioGroup } from "@headlessui/react"
import { OptionValue, ProductOption } from "@lib/swell/storefront-data-hooks/src/types"
import { classNames } from "core/utils"
import { useFormikContext, useField } from "formik"
import { useState, useEffect } from "react"
import { OptionInput } from "@lib/swell/storefront-data-hooks/src/types"

interface LabeledRadioFieldProps {
  option: ProductOption
  updateSelectionChange: any
  selected?: string
}
const LabeledRadioField = ({ option, updateSelectionChange, selected }: LabeledRadioFieldProps) => {
  const { name, values, description } = option
  const { isSubmitting } = useFormikContext()
  const [input] = useField(name)

  return (
    <RadioGroup
      {...input}
      value={selected}
      disabled={isSubmitting}
      onChange={(value: string) => {
        input.onChange({ target: { value, name } })
        const optionValueId = values.find((optionValue) => optionValue.name == value)?.id
        updateSelectionChange(name, optionValueId, value)
      }}
      className="rounded-lg border border-gray-300 p-4"
    >
      <RadioGroup.Label className="block text-sm font-medium text-gray-700">
        {name}
      </RadioGroup.Label>
      <RadioGroup.Description as="span" className="text-sm text-gray-500">
        {description}
      </RadioGroup.Description>

      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {values.map((optionValue: OptionValue) => (
          <RadioGroup.Option
            as="div"
            key={optionValue.id}
            value={optionValue.name}
            className={({ active }) =>
              classNames(
                active ? "ring-2 ring-primary-500" : "",
                "relative block cursor-pointer rounded-lg border border-gray-300 p-4 focus:outline-hidden"
              )
            }
          >
            {({ active, checked }) => (
              <>
                <RadioGroup.Label as="p" className="text-base font-medium text-gray-900">
                  {optionValue.name}
                </RadioGroup.Label>
                <RadioGroup.Description as="p" className="mt-1 text-sm text-gray-500">
                  {optionValue.description}
                </RadioGroup.Description>
                <div
                  className={classNames(
                    active ? "border" : "border-2",
                    checked ? "border-primary-500" : "border-transparent",
                    "pointer-events-none absolute -inset-px rounded-lg"
                  )}
                  aria-hidden="true"
                />
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )
}
export default LabeledRadioField
